"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCToken;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

/**
 * Created by bd on 2019-08-07.
 */
function getCToken() {
  var tokenCookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ctoken';
  return _jsCookie.default.get(tokenCookieName);
}